import { MouseEventHandler } from 'react';

export enum MouseButton {
  Left = 0,
  Middle = 1,
  Right = 2,
}

export const stopPropagation: MouseEventHandler<any> = (e) => {
  e.stopPropagation();
};
